import React, { Fragment } from 'react';
import { TFieldDetails } from '../../types/mvpCharts';
import { Grid, IconButton, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LinearProgress from '@mui/material/LinearProgress';
import dayjs from 'dayjs';

type TChartFieldDetailsProps = {
  fieldDetails: TFieldDetails & {
    index?: string | null;
    indexValue?: number;
  };
  className?: string;
  handleOnCancel: () => void;
  isLoading: boolean;
  plotType?: string;
  fieldNumber?: number;
  onNavigate?: (tabId: string, props?: any) => void;
};

export const ChartFieldDetails: React.FC<
  TChartFieldDetailsProps
> = ({
  fieldDetails: {
    registeredArea,
    geofenceArea,
    areaUnderReported,
    sowingTime,
    harvestTime,
    growerName,
    employeeData,
    geographyData,
    index,
    indexValue,
    harvestQuantity,
    pldStatus,
  },
  fieldNumber,
  //plotType,
  className,
  handleOnCancel,
  isLoading,
  onNavigate,
}) => {
  const fieldDetailsToShow = [
    {
      label: 'Country',
      value: geographyData?.country,
    },
    {
      label: 'Region',
      value: geographyData?.region,
    },
    {
      label: 'Sub Region',
      value: geographyData?.subRegion?.toLocaleLowerCase(),
    },
    {
      label: 'Village',
      value: geographyData?.village?.toLocaleLowerCase(),
    },
    {
      label: 'Registered Area',
      value: registeredArea,
    },
    {
      label: 'Geofence Area',
      value: geofenceArea,
    },
    {
      label: 'Area Under Reported',
      value: areaUnderReported?.toFixed(3),
    },
    {
      label: 'Sowing Date',
      value: sowingTime?.seconds
        ? sowingTime?.seconds > 0
          ? dayjs(sowingTime?.seconds * 1000).format(
              'DD/MM/YYYY'
            )
          : '-'
        : '-',
    },
    {
      label: 'Harvest Date',
      value: harvestTime?.seconds
        ? dayjs(harvestTime?.seconds * 1000).format(
            'DD/MM/YYYY'
          )
        : '-',
    },
    {
      label: 'Harvest Quantity',
      value: harvestQuantity,
    },
    {
      label: 'Grower Name',
      value: growerName?.toLocaleLowerCase(),
    },
    {
      label: 'Organizer',
      value: employeeData?.organizer?.toLocaleLowerCase(),
    },
    {
      label: 'FA',
      value: employeeData?.fa?.toLocaleLowerCase(),
    },
    {
      label: 'Status',
      value: harvestQuantity
        ? 'Harvested'
        : pldStatus === 'FULL_PLD_STATUS'
        ? 'PLD'
        : 'Ongoing',
    },
  ];

  if (index) {
    fieldDetailsToShow.push({
      label: index,
      value: indexValue?.toFixed(3),
    });
  }

  return (
    <div
      className={className}
      style={{
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
        padding: '8px 20px 16px',
        borderRadius: '16px',
        position: 'relative',
      }}>
      {isLoading && (
        <LinearProgress
          sx={{
            position: 'absolute',
            borderRadius: '16px 16px 0px 0px',
            margin: '0px 8px ',
            top: '0',
            left: '0',
            right: '0',
          }}
        />
      )}
      <div className="flex justify-between items-center">
        <h1 className="font-bold">
          Field Details - {fieldNumber}
        </h1>
        <IconButton
          aria-label="Close"
          onClick={handleOnCancel}>
          <CloseIcon />
        </IconButton>
      </div>
      <div
        style={{
          margin: '8px -20px',
          border: '.5px solid rgba(0, 0, 0, 0.1)',
        }}></div>
      <section className="mt-4 flex">
        <Grid container>
          {fieldDetailsToShow.map(({ label, value }) => (
            <Fragment key={label}>
              <Grid item xs={6}>
                {label}:
              </Grid>
              <Grid item xs={6}>
                {value}
              </Grid>
            </Fragment>
          ))}
        </Grid>
      </section>
      <div className="mt-4 flex justify-between  gap-x-4">
        {/* {plotType == 'timeSeriesPlot' ? (
          ''
        ) : (
          <Button
            variant="contained"
            color="primary"
            onClick={() =>
              handleNavigation('time-series-plot')
            }
            sx={{
              backgroundColor: '#006970',
              '&:hover': {
                backgroundColor: '#006970',
                boxShadow: 'none',
              },
            }}>
            Go to Time Series Plot
          </Button>
        )} */}
        <Button
          variant="contained"
          color="primary"
          onClick={() =>
            onNavigate?.('timeseries', {
              fieldId: fieldNumber,
            })
          }
          sx={{
            backgroundColor: '#006970',
            '&:hover': {
              backgroundColor: '#006970',
              boxShadow: 'none',
            },
          }}>
          View field
        </Button>
      </div>
    </div>
  );
};
